import LeaderBoard from "./Component/LeaderBoard/Leaderboard";
import "./App.css";
import StudentLeaderBoard from "./Component/StudentLeaderBoard/StudentLeaderBoard";

const App = () => {
  const type = document.getElementById("root").getAttribute("type");
  const id = document.getElementById("root").getAttribute("student_id");
  const title = document.getElementById("root").getAttribute("title");
  return type !== "student" ? (
    <LeaderBoard title={title} />
  ) : (
    <StudentLeaderBoard id={id} title={title} />
  );
};

export default App;
